import { RecommendationStateEnum } from '@coin/shared/core/util-enums';

export class SuccessionManagementHelper {
  public static getColorForRecommendationState(recommendationState: RecommendationStateEnum): string {
    const colorMap: Record<RecommendationStateEnum, string> = {
      Recommended: 'purple',
      ReviewerAccepted: 'petrol',
      Declined: 'red',
      ReviewerDeclined: 'red',
      Approved: 'petrol'
    };
    return colorMap[recommendationState];
  }
}
